export default class SpeechSynthesisEvent {
  constructor(type) {
    this.type = type;
  }
}
